import React from 'react';
import css from './PartnerPreviewFavorite.module.css';

type PartnerPreviewFavoriteProps = {
  children?: React.ReactNode;
  onClick?: () => void;
  actionLabel?: string;
};

export const PartnerPreviewFavorite = ({
  children,
  onClick,
  actionLabel = 'try',
}: PartnerPreviewFavoriteProps) => {
  return (
    <div className={css.root} onClick={onClick}>
      <div className={css.mainContent}>{children}</div>

      <div className={css.footer}>{actionLabel}</div>
    </div>
  );
};
